import { NotFound } from '../../components/common/NotFound';

export const ErrorPage = () => {
  return <NotFound /> 
}